import { isPlatformBrowser } from '@angular/common';
import { Component, inject, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  public translate = inject(TranslateService);
  
  constructor(@Inject(PLATFORM_ID) private platformId: Object,) {}

  ngOnInit(): void {}

  goToAboutUs() {
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = 'https://flight.abousamratravel.com/aboutUs';
    }
  }

  goToContactUs() {
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = 'https://flight.abousamratravel.com/contactUs';
    }
  }

  goToHome() {
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = 'https://flight.abousamratravel.com/';
    }
  }

  goToPrivacy() {
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = 'https://flight.abousamratravel.com/privacyPolicy';
    }
  }

  goToTermsOfUse() {
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = 'https://flight.abousamratravel.com/termsOfUse';
    }
  }
}
